import { render, staticRenderFns } from "./Instancing.vue?vue&type=template&id=6d2a4c4f&scoped=true&lang=pug&"
import script from "./Instancing.ts?vue&type=script&lang=ts&"
export * from "./Instancing.ts?vue&type=script&lang=ts&"
import style0 from "./Instancing.vue?vue&type=style&index=0&id=6d2a4c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a4c4f",
  null
  
)

export default component.exports